var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 9.66668C8.92113 9.66668 9.66732 8.92048 9.66732 8.00001C9.66732 7.07954 8.92113 6.33334 8.00065 6.33334C7.08018 6.33334 6.33398 7.07954 6.33398 8.00001C6.33398 8.92048 7.08018 9.66668 8.00065 9.66668Z",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 6.33334V9.66668",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 12C5.99935 12.5 5.85936 12.9733 5.61269 13.3733C5.15269 14.1467 4.30602 14.6667 3.33268 14.6667C2.35935 14.6667 1.51267 14.1467 1.05267 13.3733C0.806007 12.9733 0.666016 12.5 0.666016 12C0.666016 10.5267 1.85935 9.33334 3.33268 9.33334C4.80602 9.33334 5.99935 10.5267 5.99935 12Z",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32747 11.9863H2.34082",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 11.013V13.0063",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 10.2V5.99999C1.33398 3.66666 2.66732 2.66666 4.66732 2.66666H11.334C13.334 2.66666 14.6673 3.66666 14.6673 5.99999V9.99999C14.6673 12.3333 13.334 13.3333 11.334 13.3333H5.66732",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.ae9fcdfa87cdac982c9fbb7fbc6e183a.svg";
export { ForwardRef as ReactComponent };